//@import dependencies
import React, { CSSProperties } from 'react'
//@end

//@import components
import SurveyComponent from 'app_components/modules/survey/surveyComponent'
//@end

// @import hooks
import { useTranslation } from 'react-i18next'
// @end

// @INFO Import types
import * as InteractionTypes from 'app_events/interaction/types'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../screenwrapperModule.scss'
import ProfileInformationInteraction from 'app_components/modules/ProfileInformationInteraction/ProfileInformationInteraction'
import { useDispatch, useSelector } from 'react-redux'
import { helpStepsChange } from 'app_events/app/actions'
import { CombinedReducers } from 'app_events/index'
import UserService from 'app_services/user/userService'
import { updateUserDataAction } from 'app_events/auth/actions'
import CharacterizationSurveyModal from 'app_components/modules/CharacterizationSurveyModal/CharacterizationSurveyModal'
import StudentDashboardPendingCertificateModal from 'app_components/modules/homeScreens/StudentDashboardPage/components/StudentDashboardPendingCertificateModal/StudentDashboardPendingCertificateModal'

// @ADD Component types
interface IScreenwrapperModuleLayoutProps {
  showInteraction: boolean
  typeInteraction: InteractionTypes.TypesInteraction;
  path?: InteractionTypes.IPathInteraction
  children?: any
  resourceData?: any
  className?: string
  style?: CSSProperties
  onClose: (data?: any)=>any
}

const ScreenwrapperModuleLayout: React.FC<IScreenwrapperModuleLayoutProps> = (props) => {

  const userService: UserService = new UserService()

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const helpSteps = useSelector((store: CombinedReducers) => store?.app?.helpSteps);
  const user = useSelector((store: CombinedReducers) => store?.auth?.user?.data);

  const getInteractionComponent = () => {
    switch(props.typeInteraction) {
      case 'help_steps':
        if (helpSteps?.open === false && user?.show_profile_interaction === true) {
          dispatch(helpStepsChange({open: true}))
          if (user?.id) {
            userService.insertOrUpdate({show_profile_interaction: false}, `update/${user?.id}`).then((response) => {
              if (response) {
                const newData = user;
                newData.show_profile_interaction = false;
                dispatch(updateUserDataAction(newData));
              }
            });
          }
        }
        break;
      case 'update_profile_information':
        return (
          <ProfileInformationInteraction
            show={true}
            onClose={props.onClose}
          />
        )
      case 'survey':
        return (
          <SurveyComponent
            data={props.resourceData}
            path={props.path}
            open={true}
            onClose={props.onClose}
          />
        )
      case 'characterization_survey':
        return (
          <CharacterizationSurveyModal
            data={props.resourceData}
            path={props.path}
            open={true}
            onClose={props.onClose}
          />
        )
      case 'pending_certificate':
          return (
            <StudentDashboardPendingCertificateModal
              path={props.path}
              open={true}
              onClose={props.onClose}
            />
          )
      default:
        return null;
    }
  }

  return(
    <div
      className={`${props.className ? props.className : ''}`}
      style={props.style}
    >
      {props.showInteraction ?
        getInteractionComponent()
      :null}
      {!props.path?.shouldReplaceContent && props.children}
    </div>
  )
}

export default ScreenwrapperModuleLayout
